// JavaScript code for acf_blocks/programmes-list-block component
(($) => {

    "use strict";
    if (!$('.acf-blocks-programmes-list-block').length) {
        return;
    }
    console.log("acf_blocks/programmes-list-block scripts loaded...");

    /**
     * Update the showing status info when new content is loaded via pagination.
     */
    $(document).on('sn:pagination:load-more:loaded', function(event, htmlContent) {
        let showingInfo = $(htmlContent).find('.showing-status-info').html();
        if (showingInfo) {
            $('.showing-status-info').html(showingInfo);
        }
    });

    /**
     * Handle change events on the filter form to submit it automatically.
     */
    $('.acf-blocks-programmes-list-block form').on('change', 'input:checkbox', function(e) {
        e.preventDefault();
        $(this).submit();
    });

    /**
     * Handle form submission to fetch and display filtered programmes via AJAX.
     */
    $('.acf-blocks-programmes-list-block form').on('submit', function(e) {
        e.preventDefault();
        const form = $(this);
        const formData = form.serialize();
        $.ajax({
            url: form.attr('action'),
            method: form.attr('method'),
            data: formData,
            cache: false,
            beforeSend: function() {
                form.find('input').prop('disabled', true);
            },
            success: function(response) {
                let content = $(response).find('.programmes-list').html();
                let showingInfo = $(response).find('.showing-status-info').html();
                let paginationBlock = $(response).find('.sn-pagination-load-more');
                let paginationButton = paginationBlock.html() || '';
                if (!content) {
                    content = $(response).find('.msg-warning').prop('outerHTML');
                }
                $('.programmes-list').html(content);
                $('.showing-status-info').html(showingInfo);
                if (paginationButton) {
                    $('.sn-pagination-load-more').html(paginationButton);
                    $('.sn-pagination-load-more').show();
                }
            },
            complete: function() {
                form.find('input').prop('disabled', false);
                // scroll to programmes list
                $('html, body').scrollTop($('.acf-blocks-programmes-list-block').offset().top - 300);
            },
            error: function() {
                alert('An error occurred while fetching programmes. Please try again.');
            }
        });
    });

    /**
     * Handle the display of the comparison modal and addition of programmes to the comparison list.
     */
    $('.programmes-list').on('click', '.btn-compare', function () {
        let programmeId = $(this).data('programme-id');
        let programmeTitle = $(this).data('programme-title');
        let programmeThumbnail = $(this).data('programme-image');
        const programme = {
            id: programmeId,
            title: programmeTitle,
            thumbnail: programmeThumbnail
        };

        let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
        if (compareList.length === 4) {
            // alert('You can only compare up to 4 programmes at a time.');
            showComparisonModal();
            return;
        }
        const exists = compareList.some(item => item.id === programmeId);
        if (!exists) {
            compareList.push(programme);
            localStorage.setItem('compareList', JSON.stringify(compareList));
        }
        showComparisonModal();
    });

    /**
     * Handle removal of programmes from the comparison list in the modal.
     */
    $('.compare-modal').on('click', '.btn-remove', function () {
        let programmeId = $(this).data('programme-id');
        let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
        compareList = compareList.filter(item => item.id !== programmeId);
        localStorage.setItem('compareList', JSON.stringify(compareList));
        showComparisonModal();
    });

    /**
     * Handle proceeding to the comparison page, ensuring at least 2 programmes are selected.
     */
    $('.compare-modal .btn-proceed-to-compare').on('click', function(e) {
        let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
        if (compareList.length < 2) {
            alert('Please select at least 2 programmes to compare.');
            e.preventDefault();
        }
    });

    /**
     * Handle closing of the comparison modal.
     */
    $('.compare-modal .btn-close').on('click', function(e) {
        e.preventDefault();
        $('.compare-modal').addClass('hidden');
    });

    function showComparisonModal() {
        $('.compare-modal').removeClass('hidden');
        let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
        if (compareList.length === 0) {
            $('.no-programmes-selected').removeClass('hidden').addClass('flex');
            $('.selected-programmes').removeClass('flex').addClass('hidden');
            $('.selected-programmes .programmes-to-compare').html('');
            return;
        }

        $('.no-programmes-selected').removeClass('flex').addClass('hidden');
        $('.selected-programmes').removeClass('hidden').addClass('flex');

        let htmlCards = '';
        for (let i = 0; i < 4; i++) {
            const programme = compareList[i] ?? null;
            if (programme) {
                htmlCards += `
                    <div class="relative rounded-[10px] flex flex-col gap-[10px] items-center justify-start max-w-[160px]">
                        <img src="${programme.thumbnail}" alt="${programme.title}" class="w-full aspect-square h-auto block rounded-[10px] max-w-[200px] object-cover bg-white">
                        <h4 class="text-[14px] md:text-[18px] font-bold">${programme.title}</h4>
                        <button data-programme-id="${programme.id}" class="p-0 m-0 rounded-full bg-black cursor-pointer absolute top-[-13px] right-[-13px] w-[26px] h-[26px] btn-remove">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                              <path d="M13 0C5.83264 0 0 5.83264 0 13C0 20.1674 5.83264 26 13 26C20.1674 26 26 20.1674 26 13C26 5.83264 20.1674 0 13 0ZM13 24C6.93504 24 2 19.065 2 13C2 6.93504 6.93504 2 13 2C19.065 2 24 6.93504 24 13C24 19.065 19.065 24 13 24ZM17.7075 9.70752L14.415 13L17.7075 16.2925C18.0975 16.6825 18.0975 17.315 17.7075 17.7075C17.5125 17.9025 17.255 18 17 18C16.7451 18 16.4875 17.9025 16.2925 17.7075L13.0001 14.415L9.70758 17.7075C9.51258 17.9025 9.25507 18 9.0001 18C8.74512 18 8.48758 17.9025 8.29261 17.7075C7.90259 17.3175 7.90259 16.685 8.29261 16.2925L11.5851 13L8.29261 9.70752C7.90259 9.3175 7.90259 8.68502 8.29261 8.29251C8.68262 7.9025 9.3176 7.9025 9.70762 8.29251L13.0001 11.585L16.2926 8.29251C16.6826 7.9025 17.3176 7.9025 17.7076 8.29251C18.0976 8.68253 18.0975 9.3175 17.7075 9.70752Z" fill="white"/>
                            </svg>
                        </button>
                    </div>
                `;
            } else {
                htmlCards += `
                    <div class="relative rounded-[10px] border-[2px] border-dashed border-white flex flex-col gap-[10px] p-[25px] items-center justify-center max-w-[160px] xs:aspect-square">
                        <strong class="text-[14px] md:text-[18px] font-bold">Select to Compare</strong>
                    </div>
                `;
            }
        }
        $('.selected-programmes .programmes-to-compare').html(htmlCards);
    }

})(jQuery);